import React, { useState } from "react";

const CustomCard = ({ title, value = 0, type = "balance" }) => {
  const [isHovered, setIsHovered] = useState(false);

  const baseColors = {
    clawback: { active: "#16a34a", light: "#dcfce7", border: "#86efac" },
    recovery: { active: "#dc2626", light: "#fee2e2", border: "#fca5a5" },
    balance: { active: "#2563eb", light: "#dbeafe", border: "#93c5fd" },
  };

  const colors = baseColors[type] || baseColors.balance;

  const active = {
    borderColor: colors.border,
    bgGradient: `linear-gradient(135deg, ${colors.light} 0%, #fff 100%)`,
    textColor: colors.active,
    valueColor: colors.active,
  };

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        background: active.bgGradient,
        borderTop: `4px solid ${active.borderColor}`,
        borderRadius: "16px",
        padding: "24px",
        boxShadow: isHovered
          ? "0 4px 6px rgba(0,0,0,0.1)"
          : "0 1px 3px rgba(0,0,0,0.1)",
        cursor: "pointer",
        transition: "all 0.3s ease",
      }}
    >
      <div className="d-flex align-items-start justify-content-between">
        <div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: active.textColor,
              marginBottom: 12,
            }}
          >
            {title}
          </div>
          <div
            style={{
              fontSize: 30,
              fontWeight: 700,
              color: active.valueColor,
            }}
          >
            {value}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomCard;
